import { Component, Input, output } from '@angular/core';

import type {
  ActivitySubscriptionType,
  ActivitySubscriptionEvent,
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@recruitee/activities-types';
import { trackByValue } from '@recruitee/common';
import { TranslatePipe } from '@recruitee/i18n';
import type { IconName } from '@recruitee/user-interface';
import { BadgeComponent, IconComponent } from '@recruitee/user-interface';

import { ActivitySubscriptionsTableItemComponent } from './activity-subscriptions-table-item/activity-subscriptions-table-item.component';

@Component({
  selector: 'rt-activity-subscriptions-table-row',
  templateUrl: './activity-subscriptions-table-row.component.html',
  styleUrls: ['./activity-subscriptions-table-row.component.less'],
  host: { class: 'tr' },
  imports: [IconComponent, BadgeComponent, TranslatePipe, ActivitySubscriptionsTableItemComponent],
})
export class ActivitySubscriptionsTableRowComponent {
  @Input() public title: string;
  @Input() public icon: IconName;
  @Input() public types: ActivitySubscriptionType[];
  @Input() public eventsGroup: ActivitySubscriptionEvent[];
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public notifyInfo: boolean;
  @Input() public isNew: boolean = false;
  public changeEvents = output<ActivitySubscriptionUpdateData>();

  public trackByType = trackByValue;
}
